/**
 * 导师反馈接口（扩展⑥）。
 * 契约：
 *   POST /teams/:id/advisor-feedback-link（队长，需已绑定导师）→ 201 {token,url,expiresAt}
 *   GET  /teams/:id/feedback（队伍成员）→ {feedback}
 *   GET  /feedback/:token（公开免登录）→ FeedbackContextDto（脱敏概要；过期 404 / 已用 410）
 *   POST /feedback/:token（公开免登录）→ 201 {submitted:true}（≤500 字，消费令牌）
 */
import { api } from './client.js';
import type { AdvisorFeedbackLinkDto, FeedbackContextDto, TeamFeedbackDto } from './types.js';

const enc = encodeURIComponent;

export const advisorFeedbackApi = {
  /** 生成一次性反馈链接（仅队长；队伍需已绑定导师） */
  createLink: (teamId: string): Promise<AdvisorFeedbackLinkDto> =>
    api.post<AdvisorFeedbackLinkDto>(`/teams/${enc(teamId)}/advisor-feedback-link`),

  /** 本队收到的导师反馈（队伍成员） */
  list: (teamId: string): Promise<{ feedback: TeamFeedbackDto[] }> =>
    api.get<{ feedback: TeamFeedbackDto[] }>(`/teams/${enc(teamId)}/feedback`),

  /** 公开：脱敏队伍概要（导师免登录打开链接） */
  getByToken: (token: string): Promise<FeedbackContextDto> =>
    api.get<FeedbackContextDto>(`/feedback/${enc(token)}`, false),

  /** 公开：提交反馈并消费令牌（一次性） */
  submitByToken: (token: string, content: string): Promise<{ submitted: boolean }> =>
    api.post<{ submitted: boolean }>(`/feedback/${enc(token)}`, { content }, false),
};
